//video player
const playButtons = document.getElementsByClassName('play');

if (playButtons != null) {
	for (let i = 0; i < playButtons.length; i++) {
		let playButton = playButtons[i];
		let poster = document.getElementById('poster');
		playButton.addEventListener('click', () => {
			//find the id of the button
			let playId = playButton.id;
			//use it to find the id of the video
			let videoId = playId.replace('play', 'video');
			let video = document.getElementById(videoId);
			//play video
			video.play();
			//hide play button
			playButton.classList.add('hidden');
			//and the poster
			poster.classList.add('hidden');
			//show controls so user can pause/adjust volume etc
			video.setAttribute('controls','');
		});
	}
}
